/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500 } from "../models/UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzAPIPermissionsCatalogGetPermissionsCatalog } from "../axios/usersAuthzAPIPermissionsCatalogGetPermissionsCatalog";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey = () => ["users-authz-api", { url: '/permissions-catalog' }] as const

export type UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey = ReturnType<typeof usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey>

export function usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey()
  return queryOptions<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500>, UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return usersAuthzAPIPermissionsCatalogGetPermissionsCatalog(config)
   },
  })
}

/**
 * @description Returns a comprehensive list of all permissions from all APIs grouped by source
 * @summary Get all available permissions across all APIs
 * {@link /permissions-catalog}
 */
export function useUsersAuthzAPIPermissionsCatalogGetPermissionsCatalog<TData = UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, TQueryData = UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, TQueryKey extends QueryKey = UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryKey()

  const query = useQuery({
   ...usersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryOptions(config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}